/** @format */

import {useMemo} from 'react';
import {PRODUCT_TYPE_CARTON} from 'frontier-constants';
import {isValueMultipleOfStep} from 'frontier/utilities/dimension_validator';

export default function useSizeAutocomplete(dies, width, length, depth) {
    const defaultFilterDies = useMemo(() => {
        // If nothing is entered, we only want dies that are snapped to 1/8" increments.
        return dies.filter(die => {
            if (die.product_type_id === PRODUCT_TYPE_CARTON) {
                return (
                    isValueMultipleOfStep(die.width, 8, 3) &&
                    isValueMultipleOfStep(die.length, 8, 3) &&
                    isValueMultipleOfStep(die.depth, 8, 3)
                );
            }

            return (
                isValueMultipleOfStep(die.width, 8, 3) && isValueMultipleOfStep(die.length, 8, 3)
            );
        });
    }, [dies, width, length, depth]);

    // Constrain widths by the current length, or return all dies if no length yet.
    const filteredWidths = useMemo(() => {
        const filtered = length ? dies.filter(whereEq('length', length)) : defaultFilterDies;
        return mapUnique(filtered, die => die.width);
    }, [dies, length]);

    // Constrain lengths by the current width, or return all dies if no width yet.
    const filteredLengths = useMemo(() => {
        const filtered = width ? dies.filter(whereEq('width', width)) : defaultFilterDies;
        return mapUnique(filtered, die => die.length);
    }, [dies, width]);

    // Constrain depths by the current width and length, or return all dies if no width and length yet
    const filteredDepths = useMemo(() => {
        let filtered = defaultFilterDies;
        if (width && length) {
            filtered = dies.filter(whereEq('width', width)).filter(whereEq('length', length));
        } else if (width) {
            filtered = dies.filter(whereEq('width', width));
        } else if (length) {
            filtered = dies.filter(whereEq('length', length));
        }
        return mapUnique(filtered, die => die.depth);
    }, [dies, width, length]);

    return {dies, filteredWidths, filteredLengths, filteredDepths};
}

// eslint-disable-next-line eqeqeq -- double equals is intentional to coerce types as needed
const whereEq = (attr, val) => o => o[attr] == val;
const mapUnique = (arr, fn) => [...new Set(arr.map(fn))];

export function sortByNumericDistance(query, data) {
    if (!query) return data;
    const q = parseFloat(query);
    return data.sort((a, b) => {
        const distancea = Math.abs(parseFloat(a) - q);
        const distanceb = Math.abs(parseFloat(b) - q);
        return distancea - distanceb;
    });
}
